import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref } from "vue";
var ScalarFloatingBackdrop_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarFloatingBackdrop",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("absolute inset-0 -z-1 rounded bg-b-1 shadow-lg brightness-lifted"))), [renderSlot(_ctx.$slots, "default")], 16);
		};
	}
});
//#endregion
export { ScalarFloatingBackdrop_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarFloatingBackdrop.vue.script.js.map